import React from "react";
import ElectricityBill from "../../Component/Products/electricity-bills";

const ElectricityMain = () => {
	return <ElectricityBill />;
};

export default ElectricityMain;
